import React, { lazy } from 'react';
import ThemeToggle from './Components/ThemeToggle';

const AuroraBGDark = lazy(() => import("./Components/AuroraBGDark"));
const ProfileCard = lazy(() => import("./Components/ProfileCard"));
const SocialCard = lazy(() => import("./Components/SocialCard"));
const LikesCard = lazy(() => import("./Components/LikesCard"));
const ProjectsCard = lazy(() => import("./Components/ProjectsCard"));
const OtherCard = lazy(() => import("./Components/OtherCard"));

function App() {
  return (
    <div className="relative isolate flex min-h-screen flex-col overflow-hidden scrollbar-none bg-gray-100 text-black dark:bg-neutral-900 dark:text-gray-100">
      {/* Theme Toggle */}
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>

      <AuroraBGDark className="top-0 left-0 h-96 w-48 bg-gradient-to-r from-blue-500 via-green-300 to-transparent duration-500 " />
      <AuroraBGDark className="left-60 top-96 h-64 w-72 rounded-lg bg-gradient-to-r from-yellow-400 via-pink-600 to-transparent  duration-700" />
      <AuroraBGDark className="right-96 bottom-60 h-60 w-60 rounded-lg bg-gradient-to-r from-blue-500 via-green-400 to-transparent " />
      <AuroraBGDark className="right-0 bottom-0 h-48 w-96 rounded-full bg-gradient-to-r from-green-400 via-red-400 to-transparent" />

      <main className="flex grow flex-col justify-center p-2">
        <section>
          <div className="w-full px-4 py-16 sm:px-6 lg:px-8">
            <div className="mx-auto grid max-w-screen-lg grid-cols-1 gap-4 sm:grid-cols-12">
              <ProfileCard className="sm:col-span-6 sm:row-span-2 lg:col-span-5" />
              <SocialCard className="sm:col-span-6 lg:col-span-3" />
              <LikesCard className="sm:col-span-6 lg:col-span-4" />
              <ProjectsCard className="sm:col-span-6 lg:col-span-4" />
              <OtherCard className="sm:col-span-6 lg:col-span-3" />
            </div>
          </div>
        </section>
      </main>
      <footer className="text-md py-10 text-center text-sm opacity-60">
        © AbhayDas Damodaran
      </footer>
    </div>
  );
}

export default App;
